import styled from '@emotion/styled/macro';
import { Colors, Heading02 } from '@robinpowered/design-system';

export const SectionTitle = styled(Heading02)`
  border-bottom: 2px solid ${Colors.Tan10};
  font-size: 24px;
  padding: 16px;
`;
